<template>
  <div id="app">
      <div class="header">
          <div><img alt="Vue logo" class="logo" src="./assets/logo.png" style="" /></div>
      </div>
        <router-view></router-view>
    </div>

</template>

<script>
export default {
  name: "App",
  components: {

  },

};
</script>
<style lang="scss">
@font-face {
  font-family: newson_gls;
  src: url(./assets/fonts/NewsonGLS-WEB-Light.woff);
}

@font-face {
  font-family: newson_gls;
  src: url(./assets/fonts/NewsonGLS-WEB-Regular.woff);
  font-weight: bold;
}

@font-face {
  font-family: newson_gls;
  src: url(./assets/fonts/NewsonGLS-WEB-LightItalic.woff);
  font-style: italic;
}
#app {
   font-family: newson_gls;
}
    // body {
    //     font-family: "NewsonGLS-Regular", Verdana, sans-serif;        
    // }
    .logo{
        width: 101px;
        height: 34.05px;
      margin-left: 450px;
        margin-bottom: 20px;
        margin-top: 25px;
        @media screen and (max-width: 800px) {
            margin-left: 15px;
            margin-top: 20px;
        }
    }
    .header{

        width: 100%;
        height: 85px;
        top: 59px;
        margin-bottom: 35px;
        background: #061AB1;
    }

</style>

